import React, { useState } from "react"
import Button from "@/components/core/Button/Button"
import Input from "@/components/core/Input/Input"
import { getTranslations } from "@/components/cart/LookUpCart/localization"
import { useTranslation } from "next-i18next"
import { getCurrency } from "@/utils/helper"
import { setCustomerCartId, removeCustomerCartId } from "@/utils/cart"
import {
  createCartISCUser,
  getCart,
  setCart,
  setCartCount,
} from "@/store/features/cartSlice"
import { useDispatch, useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"
import Style from "@/components/cart/LookUpCart/index.module.scss"
import { showToast } from "@/store/features/genericSlice"
import { apim } from "@/constants/api"
import { oktaTokenEndpoint } from "@/constants/index"
import { validateEmail } from "@/js/helperV2"

const LookUpCart = ({ loadAbandonedCart }) => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(true)
  const [customerCartKey, setCustomerCartKey] = useState("")
  const [error, setError] = useState("")
  const { t } = useTranslation("cart")
  const staticText = getTranslations(t)
  const { user: { sub: userEmail } = {} } = useSelector(selectAuthState)
  const dispatch = useDispatch()

  const {
    collabrativeCartDecs = "",
    customersCartID = "",
    LoadCart = "",
    or: orText = "",
    createNewOrder = "",
    invalidcartidError,
    invalidEmailCartError,
    nocartError,
  } = staticText

  const handleChange = e => {
    const { value } = e.target
    setError("")
    setCustomerCartKey(value)
    setIsBtnDisabled(false)
  }

  const getToken = async () => {
    const response = await apim.post(
      `${oktaTokenEndpoint}?scope=guest&channel=india`,
      null,
      {
        params: {},
      }
    )
    const { access_token: accessToken = "" } = response.data
    return accessToken
  }
  const handleCreateCart = async () => {
    const guestToken = await getToken()
    await getCurrency().then(currency => {
      const cartPayload = {
        currency: "INR",
      }
      removeCustomerCartId()
      dispatch(setCartCount(0))
      dispatch(createCartISCUser({ cartPayload, guestToken }))
        .unwrap()
        .then(res => {
          setCustomerCartId(res.id)
          dispatch(setCart(res))
          dispatch(
            showToast({
              message: "Cart created successfully",
              isVisible: true,
            })
          )
        })
    })
  }

  const handleLoadCart = () => {
    const payload = {}
    let valid = false
    if (customerCartKey.length === 9) {
      valid = true
      payload.klId = customerCartKey
    } else if (validateEmail(customerCartKey)) {
      valid = true
      payload.email = customerCartKey
    }
    if (valid) {
      dispatch(getCart(payload))
        .unwrap()
        .then(res => {
          setError("")
          if (res.cartState === "Ordered") {
            setError("order is placed for this cart.")
            dispatch(setCart({}))
          } else if (res.id && res?.lineItems?.length) {
            setCustomerCartId(res.id)
            loadAbandonedCart(true)
          } else if (res?.lineItems?.length === 0) {
            setError("No lineitems present for your cart.")
            dispatch(setCart({}))
          } else {
            setError(nocartError)
          }
        })
        .catch(error => {
          if (customerCartKey.length === 9) {
            setError(invalidcartidError)
          } else {
            setError(nocartError)
          }
        })
    } else {
      setError(invalidcartidError)
    }
  }

  return (
    <div className={Style.cartIsfcUser}>
      <div className="cart-ifsc-section">
        <div className="isfc-description">{collabrativeCartDecs}</div>
        <div className="isfc-cart__input-group">
          <Input
            id="customers-cart-id"
            type="text"
            label={customersCartID}
            value={customerCartKey}
            showError={error}
            errorMessage={error}
            onChange={handleChange}
            autoComplete="off"
          />
          <Button
            role="button"
            tabIndex="0"
            label={LoadCart}
            size="large"
            type="black"
            className="cart-load"
            disabled={customerCartKey !== "" ? false : true}
            onClick={handleLoadCart}
          />
          <div className="btn-group">
            <div className="middle-or">{orText}</div>
            <Button
              className={"create-cart-button"}
              role="button"
              tabIndex="0"
              label={createNewOrder}
              size="large"
              type="ghost"
              onClick={handleCreateCart}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LookUpCart
